import React from 'react'

const Footer = () => {
  return (
    <footer className="bg-green text-white">
    <div className="container text-center">&copy; 2024 UNS. All rights reserved.</div>
  </footer>
  )
}

export default Footer